module.exports = __webpack_public_path__ + "static/media/signup-log.e0ef67f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/signup-log.jpg
// module id = 1243
// module chunks = 1